<template>
  <div id="ArticleListPage">
    <div id="ListContainer" :style="ListContainerStyle">
      <transition :enter-active-class="'slideIn'+listInDirecter"
                  :leave-active-class="'slideOut'+listOutDirecter">
        <component class="animated" style="position: absolute;left:0px;top:0px;animation-duration: 0.3s;-webkit-animation-duration: 0.3s;" :is="classPage"></component>
      </transition>
    </div>
    <div id="ClassLabelContainer">
      <div class="ClassLabel">
      <img :src="require('../../assets/1st/nav_bt_1_'+(thisClass==0?'s':'ns')+'.png')"
           @click="viewClass(0)">
      </div>
      <div class="ClassLabel">
      <img :src="require('../../assets/1st/nav_bt_3_'+(thisClass==2?'s':'ns')+'.png')"
           @click="viewClass(2)">
      </div>
      <div class="ClassLabel">
      <img :src="require('../../assets/1st/nav_bt_2_'+(thisClass==1?'s':'ns')+'.png')"
            @click="viewClass(1)">
      </div>
    </div>
  </div>
</template>

<script>
  import List1 from "./List1";
  import List2 from "./List2";
  import List3 from "./List3";
  import store from "../../store/1st"

  export default {
    name: "ArticleList",
    store,
    data(){
      return {
        allClasses:[
        ],
        listInDirecter:'Left',
        listOutDirecter:'Right',
      }
    },
    mounted:function () {
      let ShareInfo={
        title:"短视频与城市繁荣：打造城市金名片",
        desc: "《域见中国》首期 巨量引擎联动清华大学国家形象传播研究中心重磅推出",
        link: "https://www.primomedia.cn/m/oceanengine/oe_yujian/1st.html#/ArticleList",
        icon: "icon.jpg",
        count:0
      };
      this.$store.commit('setShareInfo',ShareInfo);
      this.setZhuanFa();
    },
    methods:{
      viewClass:function (key) {
        let index=[0,2,1];
        if(index.indexOf(this.thisClass)<index.indexOf(key)){
          this.listInDirecter='Right';
          this.listOutDirecter='Left';
        }else{
          this.listInDirecter='Left';
          this.listOutDirecter='Right';
        }
        this.$store.commit('SetClass',key)
      },
      count:function (isshare,id){
        let params = new URLSearchParams();
        params.append('id', id);
        params.append('issue', 1);
        params.append('isshare', isshare);
        let isview=this.$cookies.get('isview_'+id);
        if(isview) {
          params.append('isview', 1);
        }else{
          params.append('isview', 0);
          this.$cookies.set('isview_'+id,1,'1d')
        }

        this.axios.post('count.php',params)
          .then((response)=>{
          })
          .catch((error)=>{
            console.log(error);
          });
      },
      setZhuanFa:function (){
        let shareData = {
          title:this.$store.state.ShareInfo.title,
          desc: this.$store.state.ShareInfo.desc,
          link: this.$store.state.ShareInfo.link,
          imgUrl: require('../../assets/1st/'+this.$store.state.ShareInfo.icon),
          success:function(){
            this.count(1,this.$store.state.ShareInfo.count);
          }.bind(this)
        };
        wx.onMenuShareAppMessage(shareData);
        wx.onMenuShareTimeline(shareData);
      }
    },
    computed:{
      ListContainerStyle:function () {
        return {
          height:(this.$store.state.WindowSize.WindowHeightRem-24.3)+'rem',
        }
      },
      classPage:function () {
        switch (this.thisClass) {
          case 0:
            return List1;
          case 1:
            return List2;
          case 2:
            return List3;
          default:
            return List1;
        }
      },
      thisClass(){
        return this.$store.state.thisClass
      }
    }
  }
</script>

<style scoped>
  #ArticleListPage{
    width: 112.5rem;
    overflow: hidden;
    display: block;
    box-shadow: 0rem 0rem 2rem 0.1rem #ccc;
  }
  #ListContainer{
    position: relative;
    overflow: hidden;
    width: 100%;
  }
  #ClassLabelContainer{
    width: 112.5rem;
    height: 24.3rem;
    background: #ffffff;
    /*box-shadow: 0rem 0rem 20rem 10rem #000;*/
  }
  .ClassLabel{
    width:33.33%;
    height: 11.2rem;
    margin-top: 6.5rem;
    text-align: center;
    /*padding-left: 11.65rem;*/
    /*padding-right: 11.65rem;*/
    /*display: block;*/
    /*float: left;*/
  }
  .ClassLabel img{
    width:16rem;
    /*height: 100%;*/
    /*margin-top: 6.5rem;*/
    /*padding-left: 11.65rem;*/
    /*padding-right: 11.65rem;*/
    /*display: block;*/
    /*float: left;*/
  }
  #ClassLineContainer{
    width: 100%;
    height: 1.1rem;
  }
  #ClassLine{
    background: #ffbf00;
    width: 33.33%;
    height: 1.1rem;
    transition-duration: 0.5s;
  }
</style>



// WEBPACK FOOTER //
// src/components/1st/ArticleList.vue